import { Component, Input, ViewChild } from '@angular/core';
import { OverlayType } from './overlay.constant';
import { OverlayModel } from './overlay.model';
import { OverlayService } from './overlay.service';
import { NgIf } from '@angular/common';
import { DynamicComponentDirective } from '../../directives';

@Component({
	standalone: true,
	selector: 'overlay-management',
	templateUrl: './overlay-management.component.html',
	imports: [NgIf, DynamicComponentDirective]
})
export class OverlayManagementComponent {
	@ViewChild(DynamicComponentDirective, { static: true }) private appDynamic!: DynamicComponentDirective;

	@Input() set overlay(value: OverlayModel) {
		this.createComponent(value);
	}
	@Input() isMobile = false;

	public get OverlayType(): typeof OverlayType {
		return OverlayType;
	}
	constructor(public readonly overlayService: OverlayService) {}

	closeForm() {
		this.overlayService.hideOverlay();
	}

	createComponent(value: OverlayModel) {
		let viewContainerRef;
		if (!this.appDynamic || !value?.component) {
			viewContainerRef = this.appDynamic?.viewContainerRef;
			viewContainerRef.clear();
			return;
		}

		viewContainerRef = this.appDynamic?.viewContainerRef;
		viewContainerRef.clear();
		const componentRef = viewContainerRef.createComponent(value?.component);
		if (value?.class) componentRef.location.nativeElement.className = value.class;
		value.input?.forEach(value => {
			componentRef.setInput(value.inputName, value.inputValue);
		});
		value?.output?.forEach(output => {
			componentRef.instance[output?.outputName].subscribe(val => {
				output?.outputCallBack?.(val);
				if (output?.closeForm) {
					this.closeForm();
				}
			});
		});
	}
}
